import { render, staticRenderFns } from "./AddRecord.vue?vue&type=template&id=d185376e&scoped=true&"
import script from "./AddRecord.vue?vue&type=script&lang=js&"
export * from "./AddRecord.vue?vue&type=script&lang=js&"
import style0 from "./AddRecord.vue?vue&type=style&index=0&id=d185376e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d185376e",
  null
  
)

export default component.exports